import React from 'react';
import { tokens as t, fonts as font } from '../../tokens';

export function Modal({ open, onClose, title, size = "md", children, footer }) {
  if (!open) return null;

  const widths = { sm: 360, md: 480, lg: 640, xl: 800 };

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed", inset: 0,
        background: "rgba(0,0,0,0.45)",
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 200,
        animation: "fadeUp 0.2s ease",
        fontFamily: font.body,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: t.surface,
          borderRadius: 14,
          padding: 24,
          width: "90%",
          maxWidth: widths[size] || widths.md,
          maxHeight: "90vh",
          overflowY: "auto",
          boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
        }}
      >
        {title && (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
            <h2 style={{ fontSize: 18, fontWeight: 700, color: t.textPrimary, margin: 0 }}>{title}</h2>
            <button
              onClick={onClose}
              style={{ background: "none", border: "none", cursor: "pointer", color: t.textMuted, fontSize: 22, lineHeight: 1, padding: 4, transition: "color 0.15s" }}
            >&times;</button>
          </div>
        )}
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>{children}</div>
        {footer && (
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 24 }}>{footer}</div>
        )}
      </div>
    </div>
  );
}

export function ModalError({ children }) {
  if (!children) return null;
  return (
    <div style={{
      fontSize: 13, color: t.coral, background: t.coralLight,
      border: `1px solid ${t.coral}40`, padding: 12, borderRadius: 8,
      fontFamily: font.body,
    }}>{children}</div>
  );
}
